export const SET_ALL_BRANDS = 'SET_ALL_BRANDS'
export const ADD_NEW_BRAND = 'ADD_NEW_BRAND'
export const DELETE_BRAND = 'DELETE_BRAND'
export const UPDATE_EXISTING_BRAND = 'UPDATE_EXISTING_BRAND'
